export default __webpack_public_path__ + "static/media/TVS Sport 100 ELS catalogo 2021.14f08e86.pdf";